export class WhatsappContactMapper {
  static removeSpaces(phone: string): string {
    return phone.replace(/\s/g, "");
  }
}
